import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import GuestHome from "../guest/home/index";
import AuthenticatedRoutes from "../../routes/userRouting/AuthenticatedRoutes";

import "./styles/index.scss";
import { getUserId, getUserRole } from "../../reducers/selectors";
import ThrowErrorPage from "../common/errors/ThrowErrorPage/ThrowErrorPage";
import { AdminRoutes } from "../../routes/admin/AdminRoutes";

interface HomeProps {
  userId: string;
  userRole: string;
  location: { pathname: string };
}

class Home extends Component<HomeProps> {
  state = {
    isScrollBottom: false,
  };

  //TODO: burn this with fire (eg remove it)
  getHomeClassName = () => {
    const { location } = this.props;
    const partsOfLocation = location.pathname.split("/");
    const pathname = location.pathname;
    let result = "home-container";

    if (
      pathname.indexOf(`/forms`) > -1 &&
      "forms" !== partsOfLocation[partsOfLocation.length - 1] &&
      "forms" !== partsOfLocation[partsOfLocation.length - 2]
    ) {
      result += " form-fix";
    }
    if (pathname.indexOf(`/before-create`) > -1) {
      result += " deals-fix";
    } else {
      result += " deals-forms";
    }
    return result;
  };

  render() {
    const { userRole } = this.props;

    return (
      <div className={this.getHomeClassName()}>
        {!userRole && <GuestHome />}
        {userRole && userRole != "1" && (
          <Switch>
            <Route exact path={`/throwtesterror`} component={ThrowErrorPage} />
            <Route path={"/"} component={() => <AuthenticatedRoutes />} />
          </Switch>
        )}
        {userRole && userRole == "1" && (
          <Switch>
            <Route path={"/"} component={() => <AdminRoutes />} />
          </Switch>
        )}
        <div className="popup-overlay" />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userRole: getUserRole(state),
    userId: getUserId(state),
  };
};

export default connect(mapStateToProps)(Home);
